import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import PersonValidationResponse from 'src/models/responseTypes/PersonValidationResponse';

export type PersonValidateDataState = {
  personValidateData: PersonValidationResponse;
  beneficiaryPersonValidateData: PersonValidationResponse;
};

export const initialState: PersonValidateDataState = {
  personValidateData: {
    isValidPerson: true,
    personExist: false,
    possibleIssue: null,
    personInnova: null,
  },
  beneficiaryPersonValidateData: {
    isValidPerson: true,
    personExist: false,
    possibleIssue: null,
    personInnova: null,
  },
};

const personValidateSlice = createSlice({
  name: 'personValidateSlice',
  initialState,
  reducers: {
    overwritePerson: (
      _,
      action: PayloadAction<PersonValidateDataState>,
    ): PersonValidateDataState => {
      return action.payload;
    },
    updateSearchValidatePerson: (
      state,
      action: PayloadAction<PersonValidationResponse>,
    ): void => {
      state.personValidateData = action.payload;
    },
    updateSearchValidateBeneficiaryPerson: (
      state,
      action: PayloadAction<PersonValidationResponse>,
    ): void => {
      state.beneficiaryPersonValidateData = action.payload;
    },
  },
});

export const {
  overwritePerson,
  updateSearchValidatePerson,
  updateSearchValidateBeneficiaryPerson,
} = personValidateSlice.actions;

export default personValidateSlice.reducer;
